import { useAuthenticated } from "@/zapi-admin/shared/hooks/useAuthenticated";
import { useHistoricalNavigate } from "@/zapi-admin/shared/hooks/useHistoricalNavigate";
import { type ReactElement } from "react";
import { AppFooter } from "@/zapi-admin/shared/components/AppFooter/AppFooter";

type TProps = {
  children: ReactElement;
};

export function NonProtectedRoute({ children }: TProps) {
  const { navigate } = useHistoricalNavigate();
  const { isAuthenticated, isLoading } = useAuthenticated();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    navigate("/");
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">{children}</div>
      <AppFooter />
    </div>
  );
}
